import React from "react";
import Link from "gatsby-link";

import {
  Jumbotron,
  Grid,
  Row,
  Col,
  Image,
  Button,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Tabs,
  Tab,
  TabContainer,
  TabContent,
  TabPane
} from "react-bootstrap";
import AltHeader from "../../components/alt-header.js";
import UpNext from "../../components/up-next.js";
import Layout from "../../components/Layout";
import Job from "../../components/job.js";
import JobHeader from "../../components/job-header.js";
const MarionnaudPage = () => (
  <Layout>
    <JobHeader
      image="/img/marionnaud-header2.jpg"
      title="Marionnaud"
      subtitle="An inspirational blog for Marionnaud"
      text="Web Design / Design Lead / Prototyping / Framer"
    />

    <Row className="show-grid side-padding intro">
      <Col xs={12} sm={10} smOffset={2} md={12} mdOffset={2}>
        <h2>My Role</h2>
        <p className="job-text">
            My main role in this project was to be the Design Lead. I worked on
            the design whilst reporting to my manager and presented it to the
            COO of A.S Watson, the business units and various suppliers
            including Chanel. Whilst working on the project I took out user
            tests by creating high fidelity prototypes in Framer. I also lead
            various sub projects, including designing new emails and a new
            version of the blog, where I managed the work loads and time of
            other members of the design team.{" "}
        </p>
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src="/img/marionnaud/marionnaud-pdp.jpg" />
      </Col>
    </Row>
    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src="/img/marionnaud/marionnaud-plp-2.jpg" />
      </Col>
    </Row>

    <Row className="show-grid">
      <Col xs={12} md={12}>
        <Image src="/img/marionnaud/marionnaud-brand.jpg" />
      </Col>
    </Row>

    <UpNext
      image1="/img/superdrug-mobile-card.jpg"
      title1="Superdrug Mobile"
      text1="Creating a mobile brand from scratch"
      url1="/superdrug-mobile/"
      image2="/img/perfumeshop-card.jpg"
      title2="The Perfume Shop"
      text2="A fragrance specialist based in the UK"
      url2="/perfume-shop"
      image3="/img/spread-co-card.jpg"
      title3="Spread Co"
      text3="A financial spread betting company"
      url3="/spread-co/"
    />
  </Layout>
);

export default MarionnaudPage;
